export const updateTitle = (titleObject) => {
    return {
        type: 'UPDATE_TITLE',
        payload: titleObject
    }
}



// WEBPACK FOOTER //
// ./src/SectionTitle/actions.js